module.exports = __webpack_public_path__ + "static/img/quick_link05.9b5808b6.png";